import type { Tenant, TenantsResponse, CreateTenantInput } from '../types/tenant';
import { apiFetch } from './http';

export type { Tenant, TenantsResponse, CreateTenantInput };


export async function fetchTenants(): Promise<TenantsResponse> {
  return apiFetch<TenantsResponse>('/ops/tenants');
}

export async function fetchTenant(tenantId: string): Promise<Tenant> {
  return apiFetch<Tenant>(`/ops/tenants/${tenantId}`);
}

export async function createTenant(input: CreateTenantInput): Promise<Tenant> {
  return apiFetch<Tenant>('/ops/tenants', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateTenant(tenantId: string, input: Partial<Tenant>): Promise<Tenant> {
  return apiFetch<Tenant>(`/ops/tenants/${tenantId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

/**
 * Archive / unarchive a tenant. Archiving is a soft, reversible status change
 * (distinct from deleteTenant, which cascades and destroys records). Hides the
 * tenant from default views without losing history or audit trail.
 */
export async function setTenantArchived(tenantId: string, archived: boolean): Promise<Tenant> {
  return updateTenant(tenantId, { status: archived ? 'archived' : 'active' });
}

export async function deleteTenant(tenantId: string, confirmName: string): Promise<void> {
  await apiFetch(`/ops/tenants/${tenantId}`, {
    method: 'DELETE',
    body: JSON.stringify({ confirmName }),
  });
}
